import { Parroquia } from './../../_model/';
import { Provincia } from "./../../_model/";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { config } from "environments/config";
@Injectable({
  providedIn: 'root'
})
export class ParroquiaService {

constructor(private http: HttpClient) { }

getListParroquia() {
    return this.http
        .get<any>(`${config.apiUrl}/parroquia/listar`)
        .toPromise()
        .then((res) => <Parroquia[]>res.data)
        .then((data) => {
            return data;
        });
}

}
